/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profilency_profilings': {
    width: 15,
    height: 20,
    viewBox: '0 0 15 20',
    data: '<path pid="0" d="M11.336 3.252h1.76c.645 0 1.168.522 1.168 1.166v13.966c0 .645-.523 1.167-1.167 1.167H1.688a1.166 1.166 0 0 1-1.166-1.167V4.418c0-.644.522-1.166 1.166-1.166H3.45v-.245c0-.461.373-.835.835-.835h1.11a2.06 2.06 0 0 1 3.996 0h1.11c.46 0 .835.374.835.835v.245zm-7.886 1H1.688a.166.166 0 0 0-.166.166v13.966c0 .092.074.167.166.167h11.409a.167.167 0 0 0 .167-.167V4.418a.167.167 0 0 0-.167-.166h-1.761v.14a.835.835 0 0 1-.835.834H4.285a.835.835 0 0 1-.835-.835v-.14zm5.914-1.08a.97.97 0 0 1-.941-.748 1.06 1.06 0 0 0-2.06 0 .97.97 0 0 1-.942.748H4.45v1.054h5.886V3.172h-.972zM6.254 9.27a2.092 2.092 0 1 1-4.182 0 2.092 2.092 0 0 1 4.183 0zm-1 0a1.092 1.092 0 1 0-2.183 0 1.092 1.092 0 0 0 2.184 0zm1.958.5v-1h5.002v1H7.212zm-.957 4.383a2.092 2.092 0 1 1-4.184 0 2.092 2.092 0 0 1 4.184 0zm-1 0a1.092 1.092 0 1 0-2.183 0 1.092 1.092 0 0 0 2.183 0zm1.957.5v-1h5.002v1H7.212z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/profilency_profilings.js